const links = [
  { href: "#funktionen", label: "Funktionen", testid: "nav-funktionen" },
  { href: "#appstore", label: "App Store", testid: "nav-appstore" },
  { href: "#support", label: "Support", testid: "nav-support" },
];

export const Header = () => (
  <header className="sticky top-0 z-50 border-b border-teal-100 bg-white/80 backdrop-blur-md">
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
      <a href="#top" data-testid="header-logo" className="flex items-center gap-2.5">
        <img
          src="/wokivo-logo.png"
          alt="Wokivo Logo"
          className="h-11 w-11 rounded-[24%] shadow-sm"
        />
      </a>
      <nav data-testid="header-nav" className="flex items-center gap-1 sm:gap-2">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testid}
            className="rounded-full px-3 py-1.5 text-sm font-bold text-slate-600 transition-colors duration-200 hover:bg-teal-50 hover:text-teal-700 sm:px-4"
          >
            {l.label}
          </a>
        ))}
      </nav>
    </div>
  </header>
);
